import type { EdgeNamingStatus, EdgeSemanticInfo } from '../types';

const ROAD_TYPE_LABELS: Record<string, string> = {
  motorway: 'Autopista',
  motorway_link: 'Enlace de autopista',
  trunk: 'Troncal',
  trunk_link: 'Enlace troncal',
  primary: 'Vía primaria',
  primary_link: 'Enlace primario',
  secondary: 'Vía secundaria',
  secondary_link: 'Enlace secundario',
  tertiary: 'Vía terciaria',
  tertiary_link: 'Enlace terciario',
  residential: 'Calle residencial',
  service: 'Vía de servicio',
  unclassified: 'Vía urbana',
  pedestrian: 'Vía peatonal',
  cycleway: 'Ciclovía',
  footway: 'Sendero peatonal',
  living_street: 'Calle de convivencia',
  track: 'Camino',
  path: 'Senda',
};

export function getEdgeNamingStatusLabel(status: EdgeNamingStatus | null | undefined): string {
  switch (status) {
    case 'named':
      return 'Completo';
    case 'partial':
      return 'Parcial';
    case 'unnamed':
      return 'Calle sin nombre';
    case 'ambiguous':
      return 'Intersección ambigua';
    case 'missing_intersections':
      return 'Sin cruces detectados';
    case 'inferred':
      return 'Inferido';
    case 'unresolved':
    default:
      return 'No resuelto';
  }
}

export function getEdgeNamingStatusTone(status: EdgeNamingStatus | null | undefined): string {
  switch (status) {
    case 'named':
      return 'named';
    case 'partial':
      return 'partial';
    case 'unnamed':
      return 'unnamed';
    case 'ambiguous':
      return 'ambiguous';
    case 'missing_intersections':
      return 'missing';
    case 'inferred':
      return 'partial';
    case 'unresolved':
    default:
      return 'unresolved';
  }
}

export function getEdgeSemanticDisplayName(semantic: EdgeSemanticInfo | null | undefined): string {
  return semantic?.uniqueDisplayName || semantic?.displayName || 'Segmento no codificado';
}

export function getResolvedCrossStreet(candidates: string[] | null | undefined): string | null {
  if (!candidates || candidates.length !== 1) {
    return null;
  }

  return candidates[0];
}

export function getRoadTypeLabel(roadType: string | null | undefined): string {
  if (!roadType) {
    return 'No determinado';
  }

  return ROAD_TYPE_LABELS[roadType] || roadType;
}

export function formatConfidenceScore(score: number | null | undefined): string {
  if (score === null || score === undefined || Number.isNaN(score)) {
    return 'N/D';
  }

  return score.toFixed(2);
}
